import { post } from "shared/lib/api"
import displayFlash from "partners/scripts/display_flash"

export default function pinApplets(pinAppletUrl, unpinAppletUrl) {
  const updatePinnedApplets = (url, appletId) => {
    return post(url, { applet_id: appletId })
  }

  const postPinApplet = updatePinnedApplets.bind(null, pinAppletUrl)

  const postUnpinApplet = updatePinnedApplets.bind(null, unpinAppletUrl)

  let togglePinClickListener = function () {
    const element = this
    const id = element
      .closest(".web-applet-card")
      .getAttribute("data-applet-id")

    if (!element.classList.contains("pinned")) {
      const pinnedCount = document.querySelectorAll(
        "ul.pinned-applet-list .pinned"
      ).length
      if (pinnedCount >= 9) {
        displayFlash("Only nine Applets can be pinned at a time", "error")
        return
      }
      pinApplet(element)
      postPinApplet(id).then(null, () => {
        displayFlash("Could not pin this Applet", "error")
        unpinApplet(element, id)
      })
    } else {
      unpinApplet(element, id)
      postUnpinApplet(id).then(null, () => {
        displayFlash("Could not unpin this Applet", "error")
        pinApplet(element)
      })
    }
  }

  const pinApplet = element => {
    element.classList.add("pinned")
    let applet = element.closest(".web-applet-card")
    let pinnedList = document.querySelector("ul.pinned-applet-list")
    let appletClone = applet.cloneNode(/* deep=*/ true)
    pinnedList.appendChild(appletClone)
    appletClone
      .querySelector(".applet-pin")
      .addEventListener("click", togglePinClickListener)
  }

  const unpinApplet = (element, id) => {
    document
      .querySelectorAll(`.web-applet-card[data-applet-id=${id}]`)
      .forEach(card => {
        let pinButton = card.querySelector(".applet-pin")
        pinButton.classList.remove("pinned")
        if (card.closest("ul.pinned-applet-list")) {
          card.remove()
        }
      })
  }

  document
    .querySelectorAll(
      ".partner-applets-body .applet-pin, .partner-connections-body .applet-pin"
    )
    .forEach(item => {
      item.addEventListener("click", togglePinClickListener)
    })
}
